import { useEffect, useState } from "react";
import { ordersApi, settingsApi, type CheckoutResponse } from "../../api/resources.js";
import { ReceiptIssueModal } from "../../components/ReceiptIssueModal.js";

interface Props {
  result: CheckoutResponse;
  onNewOrder: () => void;
}

export function CheckoutCompletePanel({ result, onNewOrder }: Props) {
  const [printMessage, setPrintMessage] = useState(result.printResult.message);
  const [printSuccess, setPrintSuccess] = useState(result.printResult.success);
  const [reprinting, setReprinting] = useState(false);
  const [showReceiptModal, setShowReceiptModal] = useState(false);
  const [receiptDefaultDescription, setReceiptDefaultDescription] = useState("お品代として");
  const [receiptMessage, setReceiptMessage] = useState<string | null>(null);

  useEffect(() => {
    settingsApi
      .getPublic()
      .then((res) => setReceiptDefaultDescription(res.officialReceiptDefaultDescription))
      .catch(() => undefined);
  }, []);

  const handleReprint = async () => {
    setReprinting(true);
    try {
      const res = await ordersApi.reprint(result.order.id);
      setPrintMessage(res.printResult.message);
      setPrintSuccess(res.printResult.success);
    } catch (err) {
      setPrintMessage(err instanceof Error ? err.message : "再印刷に失敗しました");
      setPrintSuccess(false);
    } finally {
      setReprinting(false);
    }
  };

  return (
    <div className="card stack" style={{ maxWidth: 560, margin: "0 auto" }}>
      <h2>会計完了</h2>
      <div className="alert alert-success">
        伝票番号 {result.order.receiptNumber} の会計を確定しました。
      </div>

      <div className="cart-summary">
        <div className="cart-summary__row cart-summary__total">
          <span>合計</span>
          <span>¥{result.order.total.toLocaleString("ja-JP")}</span>
        </div>
      </div>

      {printSuccess ? (
        <div className="alert alert-success">{printMessage}</div>
      ) : (
        <div className="alert alert-error">{printMessage}</div>
      )}

      {!printSuccess && (
        <button className="btn btn-primary" onClick={() => void handleReprint()} disabled={reprinting}>
          {reprinting ? "再印刷中..." : "再印刷"}
        </button>
      )}
      {printSuccess && (
        <button className="btn" onClick={() => void handleReprint()} disabled={reprinting}>
          {reprinting ? "再印刷中..." : "再印刷（もう一部印刷）"}
        </button>
      )}

      {receiptMessage && <div className="alert alert-warning">{receiptMessage}</div>}
      <button className="btn" onClick={() => setShowReceiptModal(true)}>
        領収書発行（お客様からご要望があれば）
      </button>

      <button className="btn btn-primary btn-lg" onClick={onNewOrder}>
        次の会計へ
      </button>

      {showReceiptModal && (
        <ReceiptIssueModal
          orderId={result.order.id}
          defaultDescription={receiptDefaultDescription}
          onClose={() => setShowReceiptModal(false)}
          onIssued={(issueResult) => {
            setReceiptMessage(`【領収書】${issueResult.printResult.message}`);
            setShowReceiptModal(false);
          }}
        />
      )}
    </div>
  );
}
